import CompactIcon from "../../assets/product-list-assets/compact.svg";
import type { ProductListGroup } from "../../types";

export const physicalSecurityCompact: ProductListGroup = {
  id: "physicalSecurityCompact",
  title: "productListGroup.compact.title",
  seriesLabel: "modelCompare.seriesLabel.physicalSecurityCompact",
  icon: {
    src: CompactIcon,
    width: 16,
    height: 21,
  },
};
